import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-line transition-[background-color] duration-200 ease-out ${scrolled || open ? 'bg-ink/95 backdrop-blur' : 'bg-ink'}`} data-id="element-178" data-mp="r060xtrrbqiw">
      <span aria-hidden className="absolute inset-x-0 top-0 h-[3px] bg-brand" data-id="element-179" data-mp="3uheiecikood3" />
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-10" data-id="element-180" data-mp="6vyenmvwvebm">
        <Link to="/" className="flex flex-col whitespace-nowrap leading-tight" aria-label="Bas Menninga, naar de homepage" data-id="element-181" data-mp="bui3bv1w347o">
          <span className="font-serif text-2xl text-paper" data-id="element-182" data-mp="gmj9r0cdm0ps">Bas Menninga</span>
          <span className="hidden font-serif text-xs font-semibold italic text-amber sm:block" data-id="element-183" data-mp="ll2xn6aj5mks">muzikant en docent</span>
        </Link>

        <nav aria-label="Hoofdmenu" className="hidden items-center gap-7 xl:flex" data-id="element-184" data-mp="3k3i88fgkdrns">
          {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `whitespace-nowrap text-[11.5px] uppercase tracking-[0.1em] transition-colors duration-150 hover:text-amber ${isActive ? 'text-amber' : 'text-sand'}`} data-id="element-185" data-mp="3p3e39p7aa8r7">
              {item.label}
            </NavLink>)}
          <Link to="/contact" className="whitespace-nowrap rounded-full bg-amber px-5 py-2.5 text-xs font-bold tracking-wide text-ink transition-colors duration-150 hover:bg-amber-deep" data-id="element-186" data-mp="1ddljpwnh6k2j">
            Contact
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Menu sluiten' : 'Menu openen'} className="rounded-full p-2 text-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-amber xl:hidden" data-id="element-187" data-mp="3jcjlcp0u0hr6">
          {open ? <XIcon className="h-6 w-6" data-id="element-188" data-mp="30equ4jzklw9m" /> : <MenuIcon className="h-6 w-6" data-id="element-189" data-mp="30ez340skohfj" />}
        </button>
      </div>

      <AnimatePresence data-id="element-190" data-mp="2vn8qfo65xhky">
        {open && <motion.nav id="mobile-menu" aria-label="Mobiel menu" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-h-[calc(100vh-4rem)] overflow-y-auto border-t border-line px-5 pb-8 pt-2 xl:hidden" data-id="element-191" data-mp="2vm5xzbt6z72x">
            {[...navItems, {
          label: 'Contact',
          to: '/contact'
        }].map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `block border-b border-line py-4 font-serif text-3xl ${isActive ? 'text-amber' : 'text-paper'}`} data-id="element-192" data-mp="9hxgbwqkksg4">
                {item.label}
              </NavLink>)}
          </motion.nav>}
      </AnimatePresence>
    </header>;
}